export default __webpack_public_path__ + "static/PromptIconEight-0611e38125bf28078909750c7f4f1b0c.png";